import UsersProfile from './UsersProfile.container';

export default UsersProfile;
